import {
  Breadcrumb as FBreadcrumb,
  IBreadcrumb,
  IBreadcrumbProps as FIBreadcrumbProps,
  IBreadcrumbStyles,
  Icon,
} from '@fluentui/react';
import { forwardRef } from 'react';

import { IComponent, IconName } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { breadcrumbStylesDefault } from './Breadcrumb.styles';

export interface IBreadcrumbProps
  extends Omit<FIBreadcrumbProps, 'styles' | 'onRenderOverflowIcon'>,
    IComponent<IBreadcrumbStyles> {}

export const Breadcrumb = forwardRef<IBreadcrumb, IBreadcrumbProps>((props, ref) => {
  const { styles, ..._fProps } = props;
  const fProps: FIBreadcrumbProps = {
    ..._fProps,
    onRenderOverflowIcon: () => <Icon iconName={IconName.FabricFolder} />,
    styles: useThemeStyles<Partial<IBreadcrumbStyles>>(breadcrumbStylesDefault, styles),
  };
  return <FBreadcrumb {...fProps} componentRef={ref as any} data-test={props['data-test'] || 'breadcrumb'} />;
});
